@if(uploadSession) {
  @if(progressType === 'linear'){
    <div class="daisy-card bg-base-100 border border-base-300 shadow-xs p-3 rounded-xl hover:border-base-content/20 transition-all mb-2">
      <div class="flex items-center justify-between gap-3 mb-2">
        <!-- File Info -->
        <div class="flex items-center gap-2.5 min-w-0">
          <div class="w-8 h-8 rounded-lg bg-base-200 flex items-center justify-center shrink-0">
            @if (uploadSession.uploadStatus === 'completed') {
              <i class="fa-solid fa-file-circle-check text-success text-sm"></i>
            } @else if (uploadSession.uploadStatus === 'failed') {
              <i class="fa-solid fa-file-circle-exclamation text-error text-sm"></i>
            } @else {
              <i class="fa-solid fa-file-arrow-up text-primary text-sm"></i>
            }
          </div>
          <div class="min-w-0">
            <h6 class="text-xs font-semibold text-base-content truncate max-w-[180px] sm:max-w-xs" [title]="uploadSession ? uploadSession.file.name : ''">
              {{ uploadSession ? uploadSession.file.name : '' }}
            </h6>
            <div class="flex items-center gap-1.5 text-[11px] text-base-content/60">
              <span>{{ getFileSize(uploadSession.file.size) }}</span>
              <span>&bull;</span>
              <span class="font-medium" [class.text-success]="uploadSession.uploadStatus === 'completed'" [class.text-primary]="uploadSession.uploadStatus === 'uploading'">
                {{ uploadSession.uploadProgress | mathCeil }}%
              </span>
            </div>
          </div>
        </div>

        <!-- Action Controls -->
        <div class="flex items-center gap-1 shrink-0">
          @if (uploadSession.uploadStatus === 'completed') {
            <span class="daisy-badge daisy-badge-success daisy-badge-xs text-white gap-1 py-2 px-2">
              <i class="fa-solid fa-check text-[9px]"></i> Ready
            </span>
          } @else {
            @if(uploadSession.uploadStatus !== 'cancelled'){
              @if(uploadSession.uploadStatus === 'uploading') {
                <button
                  type="button"
                  (click)="handleUploadPause(uploadSession.id)"
                  class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-base-content/70 hover:text-base-content"
                  title="Pause Upload"
                >
                  <i class="fa-solid fa-pause text-xs"></i>
                </button>
              } @else {
                <button
                  type="button"
                  (click)="handleUploadResume(uploadSession.id)"
                  class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-primary"
                  title="Resume Upload"
                >
                  <i class="fa-solid fa-play text-xs"></i>
                </button>
              }
            }

            @if (uploadSession.uploadStatus === 'cancelled') {
              <button
                type="button"
                class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-warning"
                (click)="handleUploadRetry(uploadSession.id)"
                title="Retry Upload"
              >
                <i class="fa-solid fa-rotate-right text-xs"></i>
              </button>
            } @else {
              <button
                type="button"
                class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-error/70 hover:text-error"
                (click)="handleUploadCancel(uploadSession.id)"
                title="Cancel Upload"
              >
                <i class="fa-solid fa-xmark text-xs"></i>
              </button>
            }
          }
        </div>
      </div>

      <!-- Linear Progress Bar -->
      <progress
        class="daisy-progress h-1.5 w-full rounded-full"
        [class]="getProgressBarColor()"
        [value]="uploadSession ? uploadSession.uploadProgress : 0"
        max="100"
      ></progress>
    </div>
  } @else {
    <!-- Radial Progress Mode -->
    <div class="p-4 border border-base-200 bg-base-100 rounded-xl shadow-xs flex flex-col items-center">
      <div
        class="daisy-radial-progress text-primary group relative font-semibold text-xs"
        style="--value: {{ uploadSession ? uploadSession.uploadProgress : 0 }}"
        title="{{ uploadSession.uploadProgress | mathCeil }}%"
        [class]="getProgressBarColor()"
      >
        {{ uploadSession.uploadProgress | mathCeil }}%
        @if(uploadSession.uploadStatus !== 'completed'){
          <div class="absolute inset-0 w-fit h-fit m-auto hidden group-hover:flex items-center justify-center">
            @if(uploadSession.uploadStatus !== 'cancelled'){
              <button
                type="button"
                class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-error"
                (click)="handleUploadCancel(uploadSession.id)"
                title="Cancel Upload"
              >
                <i class="fa-solid fa-xmark text-xs"></i>
              </button>
            } @else {
              <button
                type="button"
                class="daisy-btn daisy-btn-circle daisy-btn-ghost daisy-btn-xs text-warning"
                (click)="handleUploadRetry(uploadSession.id)"
                title="Retry Upload"
              >
                <i class="fa-solid fa-rotate-right text-xs"></i>
              </button>
            }
          </div>
        }
      </div>
      <p class="text-xs font-semibold text-base-content mt-2 truncate max-w-[150px]">
        {{ formatName(uploadSession.file.name) }}
      </p>
      <p class="text-[11px] text-base-content/60">
        {{ getFileSize(uploadSession.file.size) }}
      </p>
    </div>
  }
} @else {
  <div class="flex items-center gap-2 text-error text-xs p-2">
    <i class="fa-solid fa-circle-exclamation text-sm"></i>
    <span>Invalid Upload Session!</span>
  </div>
}
